import { render, staticRenderFns } from "./ChatRemark.vue?vue&type=template&id=44cbf60d&scoped=true&lang=pug&"
import script from "./ChatRemark.vue?vue&type=script&lang=js&"
export * from "./ChatRemark.vue?vue&type=script&lang=js&"
import style0 from "./ChatRemark.vue?vue&type=style&index=0&id=44cbf60d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cbf60d",
  null
  
)

export default component.exports